import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTextbox = () => {
  return (
    <g>
      <path d="m15.1563 5.126h-14.3125a.75.75 0 0 0 -.75.75v4.248a.75.75 0 0 0 .75.75h14.3125a.75.75 0 0 0 .75-.75v-4.248a.75.75 0 0 0 -.75-.75zm-.75 4.248h-12.8125v-2.748h12.8125z" />
    </g>
  );
};

export default withIcon(IconTextbox);
